import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: 48px;\n    height: 48px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    color: ", ";\n    margin-top: 4px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    background: transparent;\n    background-clip: border-box;\n    border: 1px solid transparent;\n    padding: 8px 0;\n    margin: 8px;\n    height: 100%;\n    flex-wrap: wrap;\n    width: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n\n    &:hover, :active {\n        text-decoration: none;\n        background: ", ";\n    }\n\n    &:focus {\n        outline: 0;\n        text-decoration: none;\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    border: solid 1px ", ";\n    border-radius: 0.875rem;\n    background: ", ";\n    box-shadow: ", ";\n    transition: all 0.1s linear;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    width: 260px;\n    padding: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import App from '../icons/App';
import EvertransitLogo from '../icons/EvertransitLogo';
export var AppIcon = styled(App)(_templateObject(), function (props) {
  return props.theme.rainbow.palette.brand.main;
});
export var Dropdown = styled.div(_templateObject2(), function (props) {
  return props.theme.rainbow.palette.background.secondary;
}, function (props) {
  return props.theme.rainbow.palette.background.main;
}, function (props) {
  return props.theme.rainbow.shadows.shadow_2;
});
export var Item = styled.a(_templateObject3(), function (props) {
  return props.theme.rainbow.palette.background.highlight;
});
export var ItemLabel = styled.h1(_templateObject4(), function (props) {
  return props.theme.rainbow.palette.text.main;
});
export var SelectAppIcon = styled(EvertransitLogo)(_templateObject5());